/* Recently viewed: remembers the last 8 product handles on this device and fills the
   recently-viewed section (excluding the current product). A custom element, so the
   theme editor refills it when it re-renders the section. */

(() => {
  'use strict';

  const KEY = 'antarti.recent.v1';
  const MAX = 8;
  const A = (window.antarti = window.antarti || {});

  const read = () => {
    try {
      const list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch {
      return [];
    }
  };
  const write = (list) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch {
      /* ignore */
    }
  };

  const currentHandle = () => document.querySelector('antarti-product')?.dataset.productHandle;

  /* Record this visit once per page load, before any rail reads the list. */
  if (!A.recentRecorded) {
    A.recentRecorded = true;
    const current = currentHandle();
    if (current) write([current, ...read().filter((h) => h !== current)]);
  }

  /* The shared card section renders an h2 (right for the wishlist page); under this
     rail's own h2 the titles belong one level down. */
  const demote = (card) => {
    card.querySelectorAll('h2.product-card__title').forEach((h2) => {
      const h3 = document.createElement('h3');
      [...h2.attributes].forEach((a) => h3.setAttribute(a.name, a.value));
      h3.append(...h2.childNodes);
      h2.replaceWith(h3);
    });
    return card;
  };

  class AntartiRecentlyViewed extends HTMLElement {
    connectedCallback() {
      this.section = this.querySelector('[data-recently-viewed]');
      this.loadId = (this.loadId || 0) + 1;
      if (this.section) this.load(this.loadId);
    }

    disconnectedCallback() {
      this.loadId = (this.loadId || 0) + 1;
    }

    async load(id) {
      const section = this.section;
      const current = currentHandle();
      const previous = read().filter((h) => h !== current);
      if (!previous.length) return;
      const grid = section.querySelector('[data-recent-grid]');
      const cardUrl = section.dataset.cardUrl;
      const cards = await Promise.all(
        previous.slice(0, Number(section.dataset.limit || 4)).map(async (handle) => {
          try {
            const res = await fetch(`${cardUrl}${encodeURIComponent(handle)}?section_id=wishlist-card`);
            if (!res.ok) return null;
            const html = new DOMParser().parseFromString(await res.text(), 'text/html');
            const card = html.querySelector('.product-card');
            return card ? demote(card) : null;
          } catch {
            return null;
          }
        })
      );
      if (id !== this.loadId) return;
      const found = cards.filter(Boolean);
      if (!found.length) return;
      grid.replaceChildren(...found);
      section.hidden = false;
      window.antarti?.motion?.reveal(section, { immediate: true });
    }
  }

  (A.define || ((n, c) => customElements.get(n) || customElements.define(n, c)))('antarti-recently-viewed', AntartiRecentlyViewed);
})();
